import { Box, Stack, Typography } from '@mui/material';
import type { ElementType, ReactNode } from 'react';

import { TypographyIcon } from '../TypographyIcon/TypographyIcon';

export const Section = ({
  title,
  icon,
  action,
  'data-testid': dataTestId,
  children,
}: {
  title?: string;
  icon?: ElementType;
  action?: ReactNode;
  'data-testid'?: string;
  children: ReactNode;
}) => {
  return (
    <Box
      id="section"
      sx={({ palette }) => ({
        border: `1px solid ${palette.border.main}`,
        borderRadius: '8px',
        mx: 0,
      })}
    >
      {title ? (
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          data-testid={dataTestId}
          p={{
            sm: 3,
            xs: 2,
          }}
          width="100%"
          sx={({ palette }) => ({
            backgroundColor: palette.background.default,
            borderBottom: `1px solid ${palette.border.main}`,
          })}
        >
          {icon ? (
            <TypographyIcon icon={icon} color="black" variant="h5">
              {title}
            </TypographyIcon>
          ) : (
            <Typography color="black" variant="h5">
              {title}
            </Typography>
          )}

          <div>{action}</div>
        </Stack>
      ) : null}
      <Box
        p={{
          background: 'white',
          sm: 3,
          xs: 2,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
